<script lang="ts" setup>
  import CardLink from "@/components/CardLink.vue";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import useToast from "@/composables/toast";
  import { ToastType } from "@/models/app";
  import { useI18n } from "vue-i18n";
  import Icon from "@/components/Icon.vue";
  import * as amplitude from '@amplitude/analytics-browser';

  const subscriptionFlowStore = useSubscriptionFlowStore();
  const { t } = useI18n();

  function handleSuccess() {
    subscriptionFlowStore.canClose = true;
    if (subscriptionFlowStore.mode !== 'card') {
      subscriptionFlowStore.changeBillingStep('card-select');
    } else {
      subscriptionFlowStore.close();
      useToast(t('subscription.flow.billing.checkout.card.success'), ToastType.Success);
    }
  }

  function handleError(error: string) {
    subscriptionFlowStore.canClose = true;
    amplitude.track('Payment Failed', {
      "Error Type": error
    });
    reportError(error);
  }
</script>

<template>
  <div class="title">
    {{ $t('common.add-new-card') }}
  </div>
  <CardLink
    @linking="subscriptionFlowStore.canClose = false"
    @success="handleSuccess"
    @error="handleError"
  />
</template>

<style lang="scss" scoped>
</style>
